<template>
  <div style="width: 100%;height: 100%;">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);width: 100%;overflow-y: auto">
      <el-row style="height: 100%">
        <el-col :span="0" style="height: 100%;overflow-y: auto">
        </el-col>
        <el-col :span="24" style="height: 100%;">
          <div class="top-line"></div>
          <div class="main-content">
            <div style="height: 50px;padding-top: 10px;color: #FFFFFF;display: flex">
              <div>
                <span style="margin-left: 10px">组织：</span>
                <el-cascader v-fixZoom size="medium" class="input-el" clearable style="width: 320px"
                             :options="treeData" v-model="orgid" :filterable="true" placeholder="请选择组织"
                             :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
                             ref="orgOptions"
                             @change="changeOrgid">
                </el-cascader>
              </div>
              <div>
                <span style="margin-left: 10px">小区：</span>
                <el-select v-fixZoom class="input-el" multiple collapse-tags v-model="cids" placeholder="请选择" style="width: 300px" :clearable="true">
                  <el-option v-for="item in selectCommunity" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div style="margin-left: 10px">
                <el-button size="medium" type="primary" @click="getHealthDataNew()">查看</el-button>
              </div>
            </div>
            <div style="height: calc(100% - 60px);overflow-y: auto;">
              <div v-if="showHealthData.length === 0" style="height: 200px;line-height: 100px;text-align: center;color: white">
                <span>暂无设备。</span>
              </div>
              <div class="box-item" v-for="item in showHealthData" :key="item.id">
                <div class="bg-box">
                  <div class="address-top">
                    <div class="left-icon-home all-three-point">
                      <img style="vertical-align: middle" src="../../assets/healthIcon/room.png">
                      <span style="vertical-align: middle">{{item.h_address}}</span>
                    </div>
                    <div class="right-phone">{{ item.h_phone }}</div>
                  </div>
                  <div class="carousel-box">
                    <div class="bed-list-left">
                      <div v-if="item.bedArr.length === 0" class="bed-border">
                        <div style="height: 10px"></div>
                        <div class="one-three-top1"><span>暂无睡眠仪</span></div>
                        <div class="one-three-bed">
                          <img src="../../assets/healthIcon/bed-2-N.png">
                        </div>
                      </div>
                      <div v-if="item.bedArr.length === 1" class="bed-border">
                        <div style="height: 10px"></div>
                        <div class="one-three-top1"><span style="font-size: 16px" v-if="item.bedArr[0].person_name !== ''">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                        <div class="one-three-bed">
                          <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-2-Y.png">
                          <img v-else src="../../assets/healthIcon/bed-2-N.png">
                        </div>
                        <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 18px;text-align: center">
                          <el-row>
                            <el-col :span="12">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-2.png">
                              <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                              <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                            </el-col>
                            <el-col :span="12">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-2.png">
                              <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                              <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                            </el-col>
                          </el-row>
                        </div>
                        <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;font-size: 16px;text-align: center;color: #FFFFFF">
                          <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 18px;color: #ffcd05">
                            <span v-if="item.bedArr[0].status === 0">正常</span>
                            <span v-if="item.bedArr[0].status === 1">翻身</span>
                            <span v-if="item.bedArr[0].status === 2">安静</span>
                            <span v-if="item.bedArr[0].status === 3">动作</span>
                            <span v-if="item.bedArr[0].status === 4">持续动作</span>
                            <span v-if="item.bedArr[0].status === 5">无人</span>
                            <span v-if="item.bedArr[0].status === 6">平静</span>
                          </span>
                          <span v-else style="font-size: 18px;color: #ffcd05"> -- </span><br>
                          <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 12px;">{{item.bedArr[0].sleep_time}}</span>
                        </div>
                      </div>
                      <div v-if="item.bedArr.length === 2" class="bed-border">
                        <el-row>
                          <el-col :span="12">
                            <div class="one-bed">
                              <div style="height: 10px"></div>
                              <div class="one-three-top1"><span style="font-size: 16px" v-if="item.bedArr[0].person_name !== ''">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                              <div class="one-three-bed">
                                <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-2-Y.png">
                                <img v-else src="../../assets/healthIcon/bed-2-N.png">
                              </div>
                              <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                                <el-row>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-2.png">
                                    <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                                  </el-col>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-2.png">
                                    <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                                  </el-col>
                                </el-row>
                              </div>
                              <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                                <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 18px;color: #ffcd05">
                                  <span v-if="item.bedArr[0].status === 0">正常</span>
                                   <span v-if="item.bedArr[0].status === 1">翻身</span>
                                   <span v-if="item.bedArr[0].status === 2">安静</span>
                                   <span v-if="item.bedArr[0].status === 3">动作</span>
                                   <span v-if="item.bedArr[0].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[0].status === 5">无人</span>
                                   <span v-if="item.bedArr[0].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 18px;color: #ffcd05"> -- </span><br>
                                <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 12px;">{{item.bedArr[0].sleep_time}}</span>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="12" style="border-left: 1px solid #3a4968">
                            <div class="one-bed">
                              <div style="height: 10px"></div>
                              <div class="one-three-top1"><span style="font-size: 16px" v-if="item.bedArr[1].person_name !== ''">{{ item.bedArr[1].person_name }}</span><span v-else> -- </span></div>
                              <div class="one-three-bed">
                                <img v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" src="../../assets/healthIcon/bed-2-Y.png">
                                <img v-else src="../../assets/healthIcon/bed-2-N.png">
                              </div>
                              <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                                <el-row>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-2.png">
                                    <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[1].heartbeat}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                                  </el-col>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-2.png">
                                    <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[1].breathe}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                                  </el-col>
                                </el-row>
                              </div>
                              <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                                <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 18px;color: #ffcd05">
                                  <span v-if="item.bedArr[1].status === 0">正常</span>
                                   <span v-if="item.bedArr[1].status === 1">翻身</span>
                                   <span v-if="item.bedArr[1].status === 2">安静</span>
                                   <span v-if="item.bedArr[1].status === 3">动作</span>
                                   <span v-if="item.bedArr[1].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[1].status === 5">无人</span>
                                   <span v-if="item.bedArr[1].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 18px;color: #ffcd05"> -- </span><br>
                                <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 12px;">{{item.bedArr[1].sleep_time}}</span>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                      <div v-if="item.bedArr.length === 3" class="bed-border">
                        <el-row>
                          <el-col :span="8">
                            <div class="one-bed">
                              <div style="height: 10px"></div>
                              <div class="one-three-top1"><span style="font-size: 16px" v-if="item.bedArr[0].person_name !== ''">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                              <div class="one-three-bed">
                                <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-3-y.png">
                                <img v-else src="../../assets/healthIcon/bed-3-n.png">
                              </div>
                              <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                                <el-row>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-3.png">
                                    <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                                  </el-col>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-3.png">
                                    <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                                  </el-col>
                                </el-row>
                              </div>
                              <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                                <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                  <span v-if="item.bedArr[0].status === 0">正常</span>
                                   <span v-if="item.bedArr[0].status === 1">翻身</span>
                                   <span v-if="item.bedArr[0].status === 2">安静</span>
                                   <span v-if="item.bedArr[0].status === 3">动作</span>
                                   <span v-if="item.bedArr[0].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[0].status === 5">无人</span>
                                   <span v-if="item.bedArr[0].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 14px;color: #ffcd05"> -- </span><br>
                                <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 10px;">{{item.bedArr[0].sleep_time}}</span>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="8" style="border-left: 1px solid #3a4968">
                            <div class="one-bed">
                              <div style="height: 10px"></div>
                              <div class="one-three-top1"><span style="font-size: 16px" v-if="item.bedArr[1].person_name !== ''">{{ item.bedArr[1].person_name }}</span><span v-else> -- </span></div>
                              <div class="one-three-bed">
                                <img v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" src="../../assets/healthIcon/bed-3-y.png">
                                <img v-else src="../../assets/healthIcon/bed-3-n.png">
                              </div>
                              <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                                <el-row>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-3.png">
                                    <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[1].heartbeat}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                                  </el-col>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-3.png">
                                    <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[1].breathe}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                                  </el-col>
                                </el-row>
                              </div>
                              <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                                <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                  <span v-if="item.bedArr[1].status === 0">正常</span>
                                   <span v-if="item.bedArr[1].status === 1">翻身</span>
                                   <span v-if="item.bedArr[1].status === 2">安静</span>
                                   <span v-if="item.bedArr[1].status === 3">动作</span>
                                   <span v-if="item.bedArr[1].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[1].status === 5">无人</span>
                                   <span v-if="item.bedArr[1].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 14px;color: #ffcd05"> -- </span><br>
                                <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 10px;">{{item.bedArr[1].sleep_time}}</span>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="8" style="border-left: 1px solid #3a4968">
                            <div class="one-bed">
                              <div style="height: 10px"></div>
                              <div class="one-three-top1"><span style="font-size: 16px" v-if="item.bedArr[2].person_name !== ''">{{ item.bedArr[2].person_name }}</span><span v-else> -- </span></div>
                              <div class="one-three-bed">
                                <img v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" src="../../assets/healthIcon/bed-3-y.png">
                                <img v-else src="../../assets/healthIcon/bed-3-n.png">
                              </div>
                              <div v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" style="height: 40px;line-height:40px;font-size: 14px;text-align: center">
                                <el-row>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-3.png">
                                    <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[2].heartbeat}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                                  </el-col>
                                  <el-col :span="12">
                                    <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-3.png">
                                    <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[2].breathe}}</strong>
                                    <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                                  </el-col>
                                </el-row>
                              </div>
                              <div v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" style="height: 40px;font-size: 12px;text-align: center;color: #FFFFFF">
                                <span v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                  <span v-if="item.bedArr[2].status === 0">正常</span>
                                   <span v-if="item.bedArr[2].status === 1">翻身</span>
                                   <span v-if="item.bedArr[2].status === 2">安静</span>
                                   <span v-if="item.bedArr[2].status === 3">动作</span>
                                   <span v-if="item.bedArr[2].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[2].status === 5">无人</span>
                                   <span v-if="item.bedArr[2].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 14px;color: #ffcd05"> -- </span><br>
                                <span v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" style="font-size: 10px;">{{item.bedArr[2].sleep_time}}</span>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                      <div v-if="item.bedArr.length === 4" class="bed-border">
                        <el-row style="margin: 0 10px">
                          <el-col :span="12" style="height: 133px;border-right: 1px solid #3a4968">
                            <div class="one-three-top"></div>
                            <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[0]">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                            <el-col :span="12">
                              <div style="height: 30px;text-align: center">
                                <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                                <img v-else src="../../assets/healthIcon/bed-4-n.png">
                              </div>
                              <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                  <span v-if="item.bedArr[0].status === 0">正常</span>
                                   <span v-if="item.bedArr[0].status === 1">翻身</span>
                                   <span v-if="item.bedArr[0].status === 2">安静</span>
                                   <span v-if="item.bedArr[0].status === 3">动作</span>
                                   <span v-if="item.bedArr[0].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[0].status === 5">无人</span>
                                   <span v-if="item.bedArr[0].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                              </div>
                            </el-col>
                            <el-col v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" :span="12">
                              <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                                <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                                <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                                <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                              </div>
                              <div style="height: 30px;text-align: center;font-size: 14px;">
                                <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                                <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                                <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                              </div>
                            </el-col>
                          </el-col>
                          <el-col :span="12" style="height: 133px;border-bottom: 1px solid #3a4968">
                            <div class="one-three-top"></div>
                            <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[1]">{{ item.bedArr[1].person_name }}</span><span v-else> -- </span></div>
                            <el-col :span="12">
                              <div style="height: 30px;text-align: center">
                                <img v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                                <img v-else src="../../assets/healthIcon/bed-4-n.png">
                              </div>
                              <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                  <span v-if="item.bedArr[1].status === 0">正常</span>
                                   <span v-if="item.bedArr[1].status === 1">翻身</span>
                                   <span v-if="item.bedArr[1].status === 2">安静</span>
                                   <span v-if="item.bedArr[1].status === 3">动作</span>
                                   <span v-if="item.bedArr[1].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[1].status === 5">无人</span>
                                   <span v-if="item.bedArr[1].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                              </div>
                            </el-col>
                            <el-col v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" :span="12">
                              <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                                <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                                <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[1].heartbeat}}</strong>
                                <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                              </div>
                              <div style="height: 30px;text-align: center;font-size: 14px;">
                                <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                                <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[1].breathe}}</strong>
                                <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                              </div>
                            </el-col>
                          </el-col>
                          <el-col :span="12" style="height: 133px;border-top: 1px solid #3a4968">
                            <div class="one-three-top"></div>
                            <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[2]">{{ item.bedArr[2].person_name }}</span><span v-else> -- </span></div>
                            <el-col :span="12">
                              <div style="height: 30px;text-align: center">
                                <img v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                                <img v-else src="../../assets/healthIcon/bed-4-n.png">
                              </div>
                              <div v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                  <span v-if="item.bedArr[2].status === 0">正常</span>
                                   <span v-if="item.bedArr[2].status === 1">翻身</span>
                                   <span v-if="item.bedArr[2].status === 2">安静</span>
                                   <span v-if="item.bedArr[2].status === 3">动作</span>
                                   <span v-if="item.bedArr[2].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[2].status === 5">无人</span>
                                   <span v-if="item.bedArr[2].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                              </div>
                            </el-col>
                            <el-col v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" :span="12">
                              <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                                <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                                <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[2].heartbeat}}</strong>
                                <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                              </div>
                              <div style="height: 30px;text-align: center;font-size: 14px;">
                                <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                                <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[2].breathe}}</strong>
                                <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                              </div>
                            </el-col>
                          </el-col>
                          <el-col :span="12" style="height: 133px;border-left: 1px solid #3a4968">
                            <div class="one-three-top"></div>
                            <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[3]">{{ item.bedArr[3].person_name }}</span><span v-else> -- </span></div>
                            <el-col :span="12">
                              <div style="height: 30px;text-align: center">
                                <img v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                                <img v-else src="../../assets/healthIcon/bed-4-n.png">
                              </div>
                              <div v-if="item.bedArr[3] && item.bedArr[3].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                  <span v-if="item.bedArr[3].status === 0">正常</span>
                                   <span v-if="item.bedArr[2].status === 1">翻身</span>
                                   <span v-if="item.bedArr[2].status === 2">安静</span>
                                   <span v-if="item.bedArr[2].status === 3">动作</span>
                                   <span v-if="item.bedArr[2].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[2].status === 5">无人</span>
                                   <span v-if="item.bedArr[2].status === 6">平静</span>
                                </span>
                                <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                              </div>
                            </el-col>
                            <el-col v-if="item.bedArr[3] && item.bedArr[3].sleep_id !== 0" :span="12">
                              <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                                <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                                <strong v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[3].heartbeat}}</strong>
                                <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                              </div>
                              <div style="height: 30px;text-align: center;font-size: 14px;">
                                <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                                <strong v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[3].breathe}}</strong>
                                <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                              </div>
                            </el-col>
                          </el-col>
                        </el-row>
                      </div>
                      <div v-if="item.bedArr.length === 5 || item.bedArr.length === 6" class="bed-border">
                        <el-col :span="8" style="height: 133px;border-right: 1px solid #3a4968">
                          <div class="one-three-top"></div>
                          <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[0]">{{ item.bedArr[0].person_name }}</span><span v-else> -- </span></div>
                          <el-col :span="12">
                            <div style="height: 30px;text-align: center">
                              <img v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                              <img v-else src="../../assets/healthIcon/bed-4-n.png">
                            </div>
                            <div v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                              <span v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[0].status === 0">正常</span>
                                   <span v-if="item.bedArr[0].status === 1">翻身</span>
                                   <span v-if="item.bedArr[0].status === 2">安静</span>
                                   <span v-if="item.bedArr[0].status === 3">动作</span>
                                   <span v-if="item.bedArr[0].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[0].status === 5">无人</span>
                                   <span v-if="item.bedArr[0].status === 6">平静</span>
                              </span>
                              <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                            </div>
                          </el-col>
                          <el-col v-if="item.bedArr[0] && item.bedArr[0].sleep_id !== 0" :span="12">
                            <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                              <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[0].heartbeat}}</strong>
                              <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                            </div>
                            <div style="height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                              <strong v-if="item.bedArr[0] && item.bedArr[0].sleep_online && item.bedArr[0].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[0].breathe}}</strong>
                              <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                            </div>
                          </el-col>
                        </el-col>
                        <el-col :span="8" style="height: 133px;border-right: 1px solid #3a4968">
                          <div class="one-three-top"></div>
                          <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[1]">{{ item.bedArr[1].person_name }}</span><span v-else> -- </span></div>
                          <el-col :span="12">
                            <div style="height: 30px;text-align: center">
                              <img v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                              <img v-else src="../../assets/healthIcon/bed-4-n.png">
                            </div>
                            <div v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                              <span v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[1].status === 0">正常</span>
                                   <span v-if="item.bedArr[1].status === 1">翻身</span>
                                   <span v-if="item.bedArr[1].status === 2">安静</span>
                                   <span v-if="item.bedArr[1].status === 3">动作</span>
                                   <span v-if="item.bedArr[1].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[1].status === 5">无人</span>
                                   <span v-if="item.bedArr[1].status === 6">平静</span>
                              </span>
                              <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                            </div>
                          </el-col>
                          <el-col v-if="item.bedArr[1] && item.bedArr[1].sleep_id !== 0" :span="12">
                            <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                              <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[1].heartbeat}}</strong>
                              <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                            </div>
                            <div style="height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                              <strong v-if="item.bedArr[1] && item.bedArr[1].sleep_online && item.bedArr[1].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[1].breathe}}</strong>
                              <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                            </div>
                          </el-col>
                        </el-col>
                        <el-col :span="8" style="height: 133px;border-bottom: 1px solid #3a4968">
                          <div class="one-three-top"></div>
                          <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[2]">{{ item.bedArr[2].person_name }}</span><span v-else> -- </span></div>
                          <el-col :span="12">
                            <div style="height: 30px;text-align: center">
                              <img v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                              <img v-else src="../../assets/healthIcon/bed-4-n.png">
                            </div>
                            <div v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                              <span v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[2].status === 0">正常</span>
                                   <span v-if="item.bedArr[2].status === 1">翻身</span>
                                   <span v-if="item.bedArr[2].status === 2">安静</span>
                                   <span v-if="item.bedArr[2].status === 3">动作</span>
                                   <span v-if="item.bedArr[2].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[2].status === 5">无人</span>
                                   <span v-if="item.bedArr[2].status === 6">平静</span>
                              </span>
                              <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                            </div>
                          </el-col>
                          <el-col v-if="item.bedArr[2] && item.bedArr[2].sleep_id !== 0" :span="12">
                            <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                              <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[2].heartbeat}}</strong>
                              <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                            </div>
                            <div style="height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                              <strong v-if="item.bedArr[2] && item.bedArr[2].sleep_online && item.bedArr[2].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[2].breathe}}</strong>
                              <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                            </div>
                          </el-col>
                        </el-col>
                        <el-col :span="8" style="height: 133px;border-top: 1px solid #3a4968;border-right: 1px solid #3a4968">
                          <div class="one-three-top"></div>
                          <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[3]">{{ item.bedArr[3].person_name }}</span><span v-else> -- </span></div>
                          <el-col :span="12">
                            <div style="height: 30px;text-align: center">
                              <img v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                              <img v-else src="../../assets/healthIcon/bed-4-n.png">
                            </div>
                            <div v-if="item.bedArr[3] && item.bedArr[3].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                              <span v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[3].status === 0">正常</span>
                                   <span v-if="item.bedArr[3].status === 1">翻身</span>
                                   <span v-if="item.bedArr[3].status === 2">安静</span>
                                   <span v-if="item.bedArr[3].status === 3">动作</span>
                                   <span v-if="item.bedArr[3].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[3].status === 5">无人</span>
                                   <span v-if="item.bedArr[3].status === 6">平静</span>
                              </span>
                              <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                            </div>
                          </el-col>
                          <el-col v-if="item.bedArr[3] && item.bedArr[3].sleep_id !== 0" :span="12">
                            <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                              <strong v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[3].heartbeat}}</strong>
                              <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                            </div>
                            <div style="height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                              <strong v-if="item.bedArr[3] && item.bedArr[3].sleep_online && item.bedArr[3].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[3].breathe}}</strong>
                              <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                            </div>
                          </el-col>
                        </el-col>
                        <el-col :span="8" style="height: 133px;border-top: 1px solid #3a4968;border-right: 1px solid #3a4968">
                          <div class="one-three-top"></div>
                          <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[4]">{{ item.bedArr[4].person_name }}</span><span v-else> -- </span></div>
                          <el-col :span="12">
                            <div style="height: 30px;text-align: center">
                              <img v-if="item.bedArr[4] && item.bedArr[4].sleep_online && item.bedArr[4].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                              <img v-else src="../../assets/healthIcon/bed-4-n.png">
                            </div>
                            <div v-if="item.bedArr[4] && item.bedArr[4].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                              <span v-if="item.bedArr[4] && item.bedArr[4].sleep_online && item.bedArr[4].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[4].status === 0">正常</span>
                                   <span v-if="item.bedArr[4].status === 1">翻身</span>
                                   <span v-if="item.bedArr[4].status === 2">安静</span>
                                   <span v-if="item.bedArr[4].status === 3">动作</span>
                                   <span v-if="item.bedArr[4].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[4].status === 5">无人</span>
                                   <span v-if="item.bedArr[4].status === 6">平静</span>
                              </span>
                              <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                            </div>
                          </el-col>
                          <el-col v-if="item.bedArr[4] && item.bedArr[4].sleep_id !== 0" :span="12">
                            <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                              <strong v-if="item.bedArr[4] && item.bedArr[4].sleep_online && item.bedArr[4].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[4].heartbeat}}</strong>
                              <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                            </div>
                            <div style="height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                              <strong v-if="item.bedArr[4] && item.bedArr[4].sleep_online && item.bedArr[4].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[4].breathe}}</strong>
                              <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                            </div>
                          </el-col>
                        </el-col>
                        <el-col v-if="item.bedArr[5]" :span="8" style="height: 133px;border-right: 1px solid #3a4968">
                          <div class="one-three-top"></div>
                          <div class="one-three-top"><span style="font-size: 12px" v-if="item.bedArr[5]">{{ item.bedArr[5].person_name }}</span><span v-else> -- </span></div>
                          <el-col :span="12">
                            <div style="height: 30px;text-align: center">
                              <img v-if="item.bedArr[5] && item.bedArr[5].sleep_online && item.bedArr[5].inbed === 1" src="../../assets/healthIcon/bed-4-y.png">
                              <img v-else src="../../assets/healthIcon/bed-4-n.png">
                            </div>
                            <div v-if="item.bedArr[5] && item.bedArr[5].sleep_id !== 0" style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;color: #ffcd05">
                              <span v-if="item.bedArr[5] && item.bedArr[5].sleep_online && item.bedArr[5].inbed === 1" style="font-size: 14px;color: #ffcd05">
                                <span v-if="item.bedArr[5].status === 0">正常</span>
                                   <span v-if="item.bedArr[5].status === 1">翻身</span>
                                   <span v-if="item.bedArr[5].status === 2">安静</span>
                                   <span v-if="item.bedArr[5].status === 3">动作</span>
                                   <span v-if="item.bedArr[5].status === 4">持续动作</span>
                                   <span v-if="item.bedArr[5].status === 5">无人</span>
                                   <span v-if="item.bedArr[5].status === 6">平静</span>
                              </span>
                              <span v-else style="font-size: 14px;color: #ffcd05"> -- </span>
                            </div>
                          </el-col>
                          <el-col v-if="item.bedArr[5] && item.bedArr[5].sleep_id !== 0" :span="12">
                            <div style="height: 30px;line-height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/xinlv-4.png">
                              <strong v-if="item.bedArr[5] && item.bedArr[5].sleep_online && item.bedArr[5].heartbeat !== 0" style="vertical-align: middle;color: #ff5469"> {{item.bedArr[5].heartbeat}}</strong>
                              <strong v-else style="vertical-align: middle;color: #ff5469"> -- </strong>
                            </div>
                            <div style="height: 30px;text-align: center;font-size: 14px;">
                              <img style="vertical-align: middle" src="../../assets/healthIcon/huxi-4.png">
                              <strong v-if="item.bedArr[5] && item.bedArr[5].sleep_online && item.bedArr[5].breathe !== 0" style="vertical-align: middle;color: #64e594"> {{item.bedArr[5].breathe}}</strong>
                              <strong v-else style="vertical-align: middle;color: #64e594"> -- </strong>
                            </div>
                          </el-col>
                        </el-col>
                      </div>
                    </div>
                    <div class="toilet-right">
                      <div class="bg-toilet" v-if="item.radarArr.length === 1">
                        <div style="height: 50px"></div>
                        <div style="height: 40px;font-size: 12px;overflow-wrap: break-word;overflow-y: hidden">
                           <span>{{item.radarArr[0].remark}}</span>
                        </div>
                        <div style="height: 90px" v-if="!item.radarArr[0].radarOnlinde">
                          <img src="../../assets/healthIcon/wuren.png">
                        </div>
                        <div style="height: 90px" v-else>
                          <img v-if="item.radarArr[0].radarstatus === 'human_exist'" src="../../assets/healthIcon/youren.png">
                          <img v-else-if="item.radarArr[0].radarstatus === 'stranded_alarm'" src="../../assets/healthIcon/zhiliu.png">
                          <img v-else-if="item.radarArr[0].radarstatus === 'falldown' || item.radarArr[0].radarstatus === 'fall'" src="../../assets/healthIcon/dd1.png">
                          <img v-else src="../../assets/healthIcon/wuren.png">
                        </div>
                        <div style="height: 30px;line-height: 30px;font-size: 16px;display: flex;align-items: center;justify-content: center" v-if="item.radarArr[0].did !== 0">
                          <div v-if="!item.radarArr[0].radarOnlinde" style="width: 6px;height: 6px;border-radius: 3px;margin-right:3px;background-color: #999999"></div>
                          <div v-else style="width: 6px;height: 6px;border-radius: 3px;margin-right:3px;background-color: #00bf20"></div>
                          <div>
                            <span v-if="!item.radarArr[0].radarOnlinde" style="color: #999999">离线</span>
                            <span v-else>
                              <span v-if="item.radarArr[0].radarstatus === 'human_exist'" style="color: #22da52">有人</span>
                              <span v-else-if="item.radarArr[0].radarstatus === 'human_not_exist'" style="color: #999999">无人</span>
                              <span v-else-if="item.radarArr[0].radarstatus === 'stranded_alarm'" style="color: #f55167">滞留</span>
                              <span v-else-if="item.radarArr[0].radarstatus === 'falldown' || item.radarArr[0].radarstatus === 'fall'" style="color: #f55167">跌倒</span>
                              <strong v-if="item.radarArr[0].radarstatus === '' && item.radarArr[0].radartime === ''"> -- </strong>
                            </span>
                          </div>
                        </div>
                        <div v-if="item.radarArr[0].radarOnlinde && item.radarArr[0].radarstatus !== 'human_not_exist'" style="height: 20px;font-size: 12px">
<!--                          <span v-if="item.radarArr[0]">{{ item.radarArr[0].radartime }}</span>-->
                          <span v-if="item.radarArr[0]">{{ item.radarArr[0].radarOnTime }}</span>
                        </div>
                      </div>
                      <div class="bg-toilet" v-else-if="item.radarArr.length === 2">
                        <div :class="index === 0 ? 'list-toilet' : 'list-toilet1'" v-for="(list, index) in item.radarArr" :key="index">
                          <div style="height: 30px;font-size: 12px;overflow-wrap: break-word;overflow-y: hidden"><span>{{list.remark}}</span></div>
                          <div class="person-icon" style="display: flex;align-items: center;justify-content: center">
                            <span v-if="!list.radarOnlinde">
                              <img style="vertical-align: middle;height: 55px" src="../../assets/healthIcon/ren1.png">
                            </span>
                            <span v-else>
                              <img style="vertical-align: middle;height: 55px" v-if="list.radarstatus === 'human_exist'" src="../../assets/healthIcon/ren2.png">
                              <img style="vertical-align: middle;height: 55px" v-else-if="list.radarstatus === 'stranded_alarm'" src="../../assets/healthIcon/ren3.png">
                              <img style="vertical-align: middle;height: 55px" v-else-if="list.radarstatus === 'falldown' || list.radarstatus === 'fall'" src="../../assets/healthIcon/dd2.png">
                              <img style="vertical-align: middle;height: 55px" v-else src="../../assets/healthIcon/ren1.png">
                            </span>
                            <div v-if="!list.radarOnlinde" style="width: 6px;height: 6px;border-radius: 3px;background-color: #999999;margin: 0 5px"></div>
                            <div v-else style="width: 6px;height: 6px;border-radius: 3px;background-color: #00bf20;margin: 0 5px"></div>
                            <span v-if="!list.radarOnlinde" style="color: #999999">离线</span>
                            <span v-else>
                              <span v-if="list.radarstatus === 'human_exist'" style="color: #22da52">有人</span>
                              <span v-else-if="list.radarstatus === 'human_not_exist'" style="color: #999999">无人</span>
                              <span v-else-if="list.radarstatus === 'stranded_alarm'" style="color: #f55167">滞留</span>
                              <span v-else-if="list.radarstatus === 'falldown' || list.radarstatus === 'fall'" style="color: #f55167">跌倒</span>
                              <strong v-if="list.radarstatus === '' && list.radartime === ''"> -- </strong>
                            </span>
                          </div>
                          <div class="text-line1" v-if="list.radarOnlinde && list.radarstatus !== 'human_not_exist'" style="font-size: 12px">
<!--                            <span v-if="list">{{ list.radartime }}</span>-->
                            <span v-if="list">{{ list.radarOnTime }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="bg-toilet"  v-else-if="item.radarArr.length > 2">
                        <div :class="(index1 === 2 && item.radarArr.length === 3) ? 'list-toilet4' : 'list-toilet3'" v-for="(list1, index1) in item.radarArr" :key="index1">
                          <div style="height: 20px;font-size: 10px;overflow-wrap: break-word;overflow:hidden;"><span>{{list1.remark}}</span></div>
                          <div class="person-icon1" style="display: flex;align-items: center;justify-content: center">
                            <span v-if="!list1.radarOnlinde">
                              <img style="vertical-align: middle;height: 30px" src="../../assets/healthIcon/wu-12.png">
                            </span>
                            <span v-else>
                              <img style="vertical-align: middle;height: 30px" v-if="list1.radarstatus === 'human_exist'" src="../../assets/healthIcon/you-12.png">
                              <img style="vertical-align: middle;height: 30px" v-else-if="list1.radarstatus === 'stranded_alarm'" src="../../assets/healthIcon/bao-12.png">
                              <img style="vertical-align: middle;height: 30px" v-else-if="list1.radarstatus === 'falldown' || list1.radarstatus === 'fall'" src="../../assets/healthIcon/dd3.png">
                              <img style="vertical-align: middle;height: 30px" v-else src="../../assets/healthIcon/ren1.png">
                            </span>
                            <div v-if="!list1.radarOnlinde" style="width: 6px;height: 6px;border-radius: 3px;background-color: #999999;margin: 0 5px"></div>
                            <div v-else style="width: 6px;height: 6px;border-radius: 3px;background-color: #00bf20;margin: 0 5px"></div>
                            <span v-if="!list1.radarOnlinde" style="color: #999999">离线</span>
                            <span v-else>
                              <span v-if="list1.radarstatus === 'human_exist'" style="color: #22da52">有人</span>
                              <span v-else-if="list1.radarstatus === 'human_not_exist'" style="color: #999999">无人</span>
                              <span v-else-if="list1.radarstatus === 'stranded_alarm'" style="color: #f55167">滞留</span>
                              <span v-else-if="list1.radarstatus === 'falldown' || list1.radarstatus === 'fall'" style="color: #f55167">跌倒</span>
                              <strong v-if="list1.radarstatus === '' && list1.radartime === ''"> -- </strong>
                            </span>
                          </div>
                          <div class="text-line1" v-if="list1.radarOnlinde && list1.radarstatus !== 'human_not_exist'" style="font-size: 12px">
<!--                            <span v-if="list1">{{ list1.radartime }}</span>-->
                            <span v-if="list1">{{list1.radarOnTime}}</span>
                          </div>
                        </div>
                      </div>
                      <div class="bg-toilet" v-else>
                        <div style="height: 50px"></div>
                        <div style="height: 40px;line-height: 40px;font-size: 12px"><span></span></div>
                        <div style="height: 90px">
                          <img src="../../assets/healthIcon/wuren.png">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="clear: both"></div>
            </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :show-close="false" :visible.sync="historyOpen" v-if="historyOpen" :close-on-click-modal="false"
      class="alarm-handle" top="8vh" width="1100px">
      <chart-open :deviceRow="deviceRow" v-model="historyOpen"></chart-open>
    </el-dialog>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {queryhealthdatabycidgrouphid} from '../../api/health'
import chartOpen from './childComponents/chartOpen'
import {queryorgcommunity} from '../../api/community'
export default {
  name: 'healthPage',
  components: {chartOpen},
  data () {
    return {
      loading: false,
      // 左边
      orgid: null,
      treeData: [],
      cids: [],
      // indexShow: 0,
      orgcommunitys: [],
      selectCommunity: [],
      searchKeyword: '',
      // 右边
      healthdata: [],
      showHealthData: [],
      showDate: '',
      // listData: [],
      imgType0: [
        {url0: '/static/health/icon_rest_leave.png', url1: '/static/health/icon_rest.png'}, // 0休息（呼吸）
        {url0: '/static/health/icon_motion_leave.png', url1: '/static/health/icon_motion.png'}, // 1运动（动作）
        {url0: '/static/health/icon_leave_home_leave.png', url1: '/static/health/icon_leave_home.png'} // 2离家
      ],
      historyOpen: false,
      deviceRow: {},
      timer: null,
      timerNum: null
    }
  },
  created () {
    this.getOrgData()
    this.golobleObject.updateTableAlarm = this.mqttData // mqtt推送
  },
  mounted () {
    let vm = this
    this.timer = setInterval(() => {
      vm.getHealthDataNew()
    }, 5 * 60 * 1000)
    this.timerNum = setInterval(() => {
      vm.getEndHealthData()
    }, 30 * 1000)
  },
  destroyed () {
    clearInterval(this.timer)
    clearInterval(this.timerNum)
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  computed: {
  },
  methods: {
    // 组织
    getOrgData () {
      // this.expandedKeys = []
      this.treeData = []
      this.loading = true
      // this.isFirst = []
      queryorg().then(res => {
        this.orgData = res.data.org.filter(item => {
          if (item.org_type === 0) {
            return item
          }
        })
        // 所属组织
        let lastLevel = 100
        const arr = this.orgData
        // let ids = []
        for (let i = 0; i < arr.length; i++) {
          // ids.push(arr[i].id)
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          const child = this.arrayToNode(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
        this.getCommunityByOrgids()
      }).catch(() => {
        this.loading = false
      })
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getCommunityByOrgids () {
      queryorgcommunity().then(res => {
        this.orgcommunitys = res.data.orgcommunitys
        this.selectCommunity = this.orgcommunitys
        this.getHealthDataNew()
      }).catch(() => {})
    },
    changeOrgid (id) {
      console.log(id, this.orgid)
      if (id) {
        let arr = []
        this.orgcommunitys.forEach(item => {
          if (item.orgid === id) {
            arr.push(item)
          }
        })
        this.selectCommunity = arr
      } else {
        this.selectCommunity = this.orgcommunitys
      }
    },
    // mqtt
    mqttData (msgObj) {
      // this.getHealthDataNew()
      if (msgObj.healthdatatype === 'heartrate' || msgObj.healthdatatype === 'breath') {
        for (let i = 0; i < this.healthdata.length; i++) {
          for (let j = 0; j < this.healthdata[i].sleep_status_info.length; j++) {
            if (this.healthdata[i].sleep_status_info[j].sub_deviceid === msgObj.device_id || (this.healthdata[i].sleep_status_info[j].sub_deviceid === '' && this.healthdata[i].sleep_status_info[j].min_imei === msgObj.device_id)) {
              this.healthdata[i].sleep_status_info[j].sleep_time = msgObj.time
              this.healthdata[i].sleep_status_info[j].sleep_online = true
              if (msgObj.healthdatatype === 'breath') {
                this.healthdata[i].sleep_status_info[j].breathe = msgObj.data
              }
              if (msgObj.healthdatatype === 'heartrate') {
                this.healthdata[i].sleep_status_info[j].heartbeat = msgObj.data
              }
            }
          }
        }
      } else if (msgObj.datatype === 'sleepstatus') {
        for (let i = 0; i < this.healthdata.length; i++) {
          for (let j = 0; j < this.healthdata[i].sleep_status_info.length; j++) {
            if (this.healthdata[i].sleep_status_info[j].sub_deviceid === msgObj.device_id || (this.healthdata[i].sleep_status_info[j].sub_deviceid === '' && this.healthdata[i].sleep_status_info[j].min_imei === msgObj.device_id)) {
              this.healthdata[i].sleep_status_info[j].sleep_time = msgObj.time
              this.healthdata[i].sleep_status_info[j].sleep_online = true
              if (msgObj.breathe !== '0') {
                this.healthdata[i].sleep_status_info[j].breathe = msgObj.breathe
              }
              if (msgObj.heartbeat !== '0') {
                this.healthdata[i].sleep_status_info[j].heartbeat = msgObj.heartbeat
              }
              if (msgObj.status !== '') {
                this.healthdata[i].sleep_status_info[j].status = msgObj.status
              }
              if (msgObj.inbed !== '') {
                this.healthdata[i].sleep_status_info[j].inbed = parseFloat(msgObj.inbed)
              }
            }
          }
        }
      } else if (msgObj.datatype === 'radarstatus') {
        for (let i = 0; i < this.healthdata.length; i++) {
          for (let j = 0; j < this.healthdata[i].subradar.length; j++) {
            if (this.healthdata[i].subradar[j].sub_deviceid === msgObj.device_id || (this.healthdata[i].subradar[j].sub_deviceid === '' && this.healthdata[i].subradar[j].min_imei === msgObj.device_id)) {
              this.healthdata[i].subradar[j].last_online = msgObj.time
              this.healthdata[i].subradar[j].radartime = msgObj.time
              this.healthdata[i].subradar[j].radarstatus = msgObj.radarstatus
            }
          }
        }
      } else {
        this.getHealthDataNew()
      }
    },
    // 健康数据
    getHealthDataNew () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        orgids: this.orgid ? [this.orgid] : [],
        cids: this.cids
      }
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      this.showDate = new Date().format('yyyy-MM-dd hh:mm:ss')
      queryhealthdatabycidgrouphid(params, data).then(res => {
        let list = []
        let arr = res.data.healthdata
        for (let i = 0; i < arr.length; i++) {
          let obj = arr[i]
          list.push(obj)
        }
        this.healthdata = list
        this.getEndHealthData()
      }).catch(() => {})
    },
    getEndHealthData () {
      let hids = []
      let arr = []
      let health = this.healthdata
      for (let i = 0; i < health.length; i++) {
        if (hids.indexOf(health[i].hid) === -1) {
          hids.push(health[i].hid)
        }
      }
      for (let i = 0; i < hids.length; i++) {
        let obj = {}
        obj.hid = hids[i]
        obj.h_address = ''
        obj.h_phone = ''
        obj.bedArr = []
        obj.radarArr = []
        for (let j = 0; j < health.length; j++) {
          if (hids[i] === health[j].hid) {
            obj.h_address = health[j].h_address
            obj.h_phone = health[j].h_phone

            if (health[j].sleep_status_info !== null) {
              health[j].sleep_status_info.forEach(sleep => {
                if (sleep.did !== 0) {
                  sleep.sleep_online = false // 时间差为5分钟视为离线
                  console.log('sleep.sleep_time', sleep.sleep_time)
                  if (sleep.sleep_time !== '') {
                    const currentTime = new Date().getTime()
                    const sleepTime = new Date(sleep.sleep_time).getTime()
                    const timeDifference = currentTime - sleepTime
                    // 如果时间差小于等于5分钟(300000毫秒)，则认为设备在线
                    sleep.sleep_online = timeDifference <= 5 * 60 * 1000
                  }
                  obj.bedArr.push(sleep)
                }
              })
            }
            if (health[j].subradar !== null) {
              health[j].subradar.forEach(radar => {
                radar.radarOnlinde = false
                radar.radarOnTime = ''
                if ((radar.lastalarmtype === 'fall' || radar.lastalarmtype === 'falldown') && radar.last_alarm_time !== '') {
                  // 25分钟显示离线
                  let t1 = new Date(radar.last_online)
                  let t2 = new Date(radar.last_alarm_time)
                  if ((parseInt(t2 - t1) / 1000 / 60) > 15) {
                    radar.radarstatus = radar.lastalarmtype
                  }
                }
                // 25分钟显示离线
                let d1 = new Date(radar.last_online)
                let d2 = new Date()
                if ((parseInt(d2 - d1) / 1000 / 60) < 25) {
                  radar.radarOnlinde = true
                }
                if (radar.radartime !== '') {
                  radar.radarOnTime = this.util.calculateTimeDifference(radar.radartime)
                  // 超过一个小时视为无人
                  let t1 = new Date(radar.radartime)
                  let t2 = new Date()
                  if ((parseInt(t2 - t1) / 1000 / 60 / 60) > 1) {
                    radar.radarstatus = 'human_not_exist'
                  }
                }
                obj.radarArr.push(radar)
              })
            }
          }
        }
        arr.push(obj)
      }
      this.showHealthData = arr
      console.log('showHealthData', arr)
    }
  }
}
</script>

<style scoped>

  .top-line{
    margin: 0 20px;
    height: 1px;
    background-color: #66aacc;
  }
.main-content{
  margin: 0 20px;
  height: calc(100% - 20px);
  background-image: linear-gradient(0deg,
  #020926 0%,
  #061739 100%);
  overflow-y: auto;
}

.box-item{
  float: left;
  width: 33.3%;
}
.bg-box{
  margin: 10px;
  /*width: 400px;*/
  height: 350px;
  background: url("../../assets/healthIcon/room_bg.png") no-repeat;
  background-size: 100% 100%;
}
.address-top{
  margin: 0 15px;
  height: 40px;
  color: #FFFFFF;
  display: flex;
}
.left-icon-home{
  font-size: 18px;
  flex: 1;
  height: 40px;
  line-height: 40px;
}
.right-phone{
  font-size: 14px;
  color: #BFC7C9;
  width: 95px;
  height: 40px;
  line-height: 40px;
  text-align: right;
}
.carousel-box{
  margin-top: 10px;
  height: 280px;
}
.bed-list-left{
  width: calc(100% - 125px);
  margin-left: 15px;
  height: 280px;
  float: left;
}
.bed-border{
  padding: 10px 0;
  height: 260px;
  box-shadow: 0px 0px 9px 0px
  rgba(111, 112, 113, 0.26);
  border-radius: 3px;
  border: solid 1px #3a4968;
}
.one-bed{
  padding-top: 40px;
  height: 220px;
}
.one-three-top{
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
}
.one-three-top1{
  height: 60px;
  color: #FFFFFF;
  text-align: center;
}
.one-three-bed{
  margin-top: 10px;
  height: 50px;
  text-align: center;
}
.toilet-right{
  width: 110px;
  height: 190px;
  float: left;
}
.bg-toilet{
  margin: auto;
  width: 80px;
  height: 280px;
  box-shadow: 0px 0px 9px 0px
  rgba(111, 112, 113, 0.26);
  border-radius: 3px;
  border: solid 1px #3a4968;
  text-align: center;
  color: #FFFFFF;
  overflow-y: auto;
}
.toilet-right{
  width: 110px;
  height: 190px;
  float: left;
}
.list-toilet{
  height: 129px;
  margin: 5px;
  border-bottom: 1px solid #3A4968;
}
.list-toilet1{
  height: 129px;
  margin: 5px;
}
.text-line{
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
}
.text-line1{
  margin-top: 5px;
  height: 30px;
  font-size: 12px;
  overflow: hidden;
}
.person-icon{
  font-size: 14px;
  height: 55px;
  text-align: center;
}
.person-icon1{
  font-size: 12px;
  height: 30px;
  text-align: center;
}
.list-toilet3{
  height: 85px;
  margin: 5px;
  border-bottom: 1px solid #3A4968;
}
.list-toilet4{
  height: 85px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/healthPage.vue